@if (showErrorBanner) {
  <div
    class="text-center h-100 w-100 d-flex align-items-center justify-content-center"
  >
    <lib-ds-notice
      type="error"
      message="An error has occurred, please try again. If the issue persists, please contact support@petszel.com."
      (dismiss)="showErrorBanner = false"
    ></lib-ds-notice>
  </div>
} @else if (isLoadingContentfulData || !bodyHtml || bodyHtml === "undefined") {
  <lib-new-loading></lib-new-loading>
} @else if (contentfulEntryData && bodyHtml && bodyHtml !== "undefined") {
  <div class="row padding print-section">
    <div class="col-md-12 article-container">
      <div class="row d-flex justify-content-center">
        <div
          class="col-md-12 d-flex justify-content-center article-img-container"
        >
          <a
            class="hero-back-link"
            [routerLink]="['/pet-guide', petId]"
            aria-label="Back"
          >
            <i class="bi bi-chevron-left" aria-hidden="true"></i>
            <span>Back</span>
          </a>
          <!-- AUTHOR OVERLAY (bottom-right) -->
          @let authorName =
            contentfulEntryData?.articleAuthor?.publicauthorName;
          @let authorUrl =
            contentfulEntryData?.articleAuthor?.authorphotoSimple?.file?.url;
          @if (authorName) {
            <div class="hero-author" aria-label="Article author">
              <span class="hero-author__name">{{ authorName }}</span>

              <span class="hero-author__avatar" aria-hidden="true">
                @if (authorUrl) {
                  <img
                    class="hero-author__img"
                    [src]="'https:' + authorUrl"
                    alt=""
                  />
                }
              </span>
            </div>
          }
          @if (contentfulEntryData?.articleHeroImageSimple?.file) {
            <img
              class="jumbotron"
              [src]="
                'https:' + contentfulEntryData?.articleHeroImageSimple?.file.url
              "
              [alt]="
                contentfulEntryData?.articleHeroImageSimple?.description || ''
              "
            />
          }
        </div>

        <div class="title-stack col-12">
          @if (readingTimeMinutes(); as minutes) {
            <div class="article-meta">
              <!-- Article topic pill and separator temporarily disabled. -->

              <span class="article-meta__reading-time">
                <lib-icon
                  class="article-meta__clock"
                  iconName="clockIcon"
                  aria-hidden="true"
                ></lib-icon>

                <span>{{ minutes }} min read</span>
              </span>
            </div>
          }
          @if (contentfulEntryData?.sponsored === true) {
            <div class="sponsored-kicker" aria-label="Sponsored content">
              sponsored
            </div>
          }
          @if (contentfulEntryData?.title) {
            <h1 class="title">
              {{ contentfulEntryData?.title }}
            </h1>
          }
          @if (contentfulEntryData?.subtitle) {
            <h3 class="subtitle">
              {{ contentfulEntryData?.subtitle }}
            </h3>
          }
        </div>

        <div class="article-body">
          <div class="row">
            <div class="col-12">
              <!-- ARTICLE BODY HTML -->
              @if (bodyHtml && bodyHtml !== "undefined") {
                <div #bodyHtmlContainer class="mt-3 articles">
                  <div class="articles" [innerHTML]="getSafeHtml()"></div>
                </div>

                <!-- SENTINEL MUST ALWAYS EXIST -->
                <div
                  #articleCompleteSentinel
                  class="article-complete-sentinel"
                  aria-hidden="true"
                ></div>
                <div class="custom-divider" aria-hidden="true"></div>

                @if (showCompletionBanner) {
                  <!-- COMPLETION BANNER -->
                  <div
                    class="article-complete-banner-wrap"
                    [class.is-visible]="showCompletionBanner"
                  >
                    <div
                      class="article-complete-banner"
                      role="status"
                      aria-live="polite"
                    >
                      <div
                        class="article-complete-banner__icon"
                        aria-hidden="true"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            d="M24.875 10C24.875 8.41218 23.5878 7.125 22 7.125H10C8.41218 7.125 7.125 8.41218 7.125 10V22C7.125 23.5878 8.41218 24.875 10 24.875H22C23.5878 24.875 24.875 23.5878 24.875 22V10ZM27.125 22C27.125 24.8305 24.8305 27.125 22 27.125H10C7.16954 27.125 4.875 24.8305 4.875 22V10C4.875 7.16954 7.16954 4.875 10 4.875H22C24.8305 4.875 27.125 7.16954 27.125 10V22Z"
                            fill="#9BD97C"
                          />
                          <path
                            d="M21.2026 10.7065C21.6409 10.2662 22.3531 10.2644 22.7935 10.7026C23.2338 11.1409 23.2356 11.8531 22.7974 12.2935L14.8359 20.2935C14.6248 20.5056 14.3378 20.625 14.0386 20.625C13.7393 20.625 13.4523 20.5056 13.2412 20.2935L9.70264 16.7378C9.26445 16.2974 9.26618 15.5852 9.70654 15.147C10.1469 14.7088 10.8591 14.7105 11.2974 15.1509L14.0381 17.9053L21.2026 10.7065Z"
                            fill="#9BD97C"
                          />
                        </svg>
                      </div>

                      <div class="article-complete-banner__text">
                        <div class="article-complete-banner__title">
                          Good work!
                        </div>
                        <div class="article-complete-banner__subtitle">
                          You’ve completed this article.
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (filteredProductCTAs.length > 0) {
                  <div class="custom-divider" aria-hidden="true"></div>
                }
              }

              <!-- IMAGE & TEXT CTAS -->
              @if (filteredCTAs.length > 0) {
                <div class="mt-3 cta-grid">
                  @for (
                    cta of filteredCTAs;
                    track cta?.entryId || cta?.productTitle || $index
                  ) {
                    <div class="cta-card mb-3">
                      <img
                        class="cta-image"
                        [src]="
                          cta?.ctaImageSimple?.file?.url ||
                          '//default-image-url.png'
                        "
                        [alt]="cta?.ctaImageSimple?.description || ''"
                      />

                      <div class="row text-center w-100">
                        <div
                          class="cta-text"
                          [innerHTML]="cta?.ctaTextHtml || ''"
                        ></div>

                        @if (
                          cta.ctaButton && cta.ctaHref && cta.ctaTrackingData
                        ) {
                          <a
                            ptzCtaTracking
                            [ctaTrackingData]="cta.ctaTrackingData"
                            #trackedImageCta="ptzCtaTracking"
                            class="petszel-primary-button m-auto"
                            [href]="cta.ctaHref"
                            target="_blank"
                            rel="noopener noreferrer"
                            (click)="trackedImageCta.emitClick()"
                          >
                            {{ cta.ctaButton.ctaTextButton || "" }}
                          </a>
                        }
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- PRODUCT / SERVICE CTAS -->
              @if (filteredProductCTAs.length > 0) {
                <div class="mt-3 cta-grid">
                  @for (
                    cta of filteredProductCTAs;
                    track cta?.entryId || cta?.productTitle || $index
                  ) {
                    <div class="cta-card mb-3">
                      <img
                        class="cta-image"
                        [src]="
                          cta?.ctaImageSimple?.file?.url ||
                          '//default-image-url.png'
                        "
                        [alt]="cta?.ctaImageSimple?.description || ''"
                      />

                      <div class="row text-center w-100">
                        <div
                          class="cta-text"
                          [innerHTML]="cta?.ctaTextHtml || ''"
                        ></div>

                        <div class="cta-buttons">
                          @if (
                            cta.ctaButton1 &&
                            cta.ctaHref1 &&
                            cta.ctaTrackingData1
                          ) {
                            <a
                              ptzCtaTracking
                              [ctaTrackingData]="cta.ctaTrackingData1"
                              #trackedCta1="ptzCtaTracking"
                              class="petszel-primary-button m-1"
                              [href]="cta.ctaHref1"
                              target="_blank"
                              rel="noopener noreferrer"
                              (click)="trackedCta1.emitClick()"
                            >
                              {{ cta.ctaButton1.ctaTextButton || "" }}
                            </a>
                          }

                          @if (
                            cta.ctaButton2 &&
                            cta.ctaHref2 &&
                            cta.ctaTrackingData2
                          ) {
                            <a
                              ptzCtaTracking
                              [ctaTrackingData]="cta.ctaTrackingData2"
                              #trackedCta2="ptzCtaTracking"
                              class="petszel-primary-button m-1"
                              [href]="cta.ctaHref2"
                              target="_blank"
                              rel="noopener noreferrer"
                              (click)="trackedCta2.emitClick()"
                            >
                              {{ cta.ctaButton2.ctaTextButton || "" }}
                            </a>
                          }

                          @if (
                            cta.ctaButton3 &&
                            cta.ctaHref3 &&
                            cta.ctaTrackingData3
                          ) {
                            <a
                              ptzCtaTracking
                              [ctaTrackingData]="cta.ctaTrackingData3"
                              #trackedCta3="ptzCtaTracking"
                              class="petszel-primary-button m-1"
                              [href]="cta.ctaHref3"
                              target="_blank"
                              rel="noopener noreferrer"
                              (click)="trackedCta3.emitClick()"
                            >
                              {{ cta.ctaButton3.ctaTextButton || "" }}
                            </a>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- Continue Learning -->
              @if (cardsData.length > 0) {
                <section class="relevant-section">
                  <div class="custom-divider" aria-hidden="true"></div>

                  <div class="relevant-header">
                    <div class="relevant-font">Continue Learning</div>
                  </div>

                  <div class="relevant-content">
                    @for (card of cardsData; track trackByCard($index, card)) {
                      <a
                        class="relevant-item"
                        [routerLink]="
                          card.type === 'article'
                            ? '/articles/' + card.slug
                            : '/videos/' + card.slug
                        "
                        [queryParams]="
                          utmQP('RelevantContent', { ItemType: card.type })
                        "
                      >
                        <div class="relevant-card">
                          @if (card.sponsored === true) {
                            <span
                              class="pill-tag-relevant pill--sponsored"
                              aria-label="Sponsored content"
                            >
                              sponsored
                            </span>
                          }

                          <div
                            class="relevant-media"
                            [class.relevant-media--video]="
                              card.type === 'video'
                            "
                          >
                            <div class="relevant-thumb">
                              <img
                                class="relevant-img"
                                [src]="
                                  card.type === 'article'
                                    ? card.image
                                    : card.videoThumbnail
                                "
                                [alt]="card.title"
                              />

                              @if (card.type === "video") {
                                <span class="relevant-play" aria-hidden="true">
                                  <img
                                    class="relevant-play__img"
                                    src="/assets/new-images/play-btn.svg"
                                    alt=""
                                  />
                                </span>
                              }
                            </div>
                          </div>

                          <div class="relevant-text">
                            <div class="relevant-title">{{ card.title }}</div>

                            @if (card.subtitle) {
                              <div class="relevant-subtitle">
                                {{ card.subtitle }}
                              </div>
                            }
                          </div>
                        </div>
                      </a>
                    }
                  </div>

                  <div class="pet-guide__expert-link-wrapper">
                    <a
                      class="pet-guide__expert-link"
                      [routerLink]="['/expert-advice']"
                      [queryParams]="expertAdviceQueryParams()"
                    >
                      <span>More Expert Info</span>
                      <span
                        class="pet-guide__expert-link__chevrons"
                        aria-hidden="true"
                      ></span>
                    </a>
                  </div>

                  <div class="custom-divider" aria-hidden="true"></div>
                </section>
              }
              @if (cardsData.length === 0) {
                <div class="pet-guide__expert-link-wrapper">
                  <a
                    class="pet-guide__expert-link"
                    [routerLink]="['/expert-advice']"
                    [queryParams]="expertAdviceQueryParams()"
                  >
                    <span>More Expert Info</span>
                    <span
                      class="pet-guide__expert-link__chevrons"
                      aria-hidden="true"
                    ></span>
                  </a>
                </div>

                <div class="custom-divider" aria-hidden="true"></div>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Bottom logo -->
      <div class="article-footer-logo" aria-label="Petszel">
        <img
          class="article-footer-logo__img"
          src="/assets/new-images/petszel-logo-vertical-blue.svg"
          alt="Petszel"
        />
      </div>
    </div>
  </div>
}
